import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ICrewData } from '../../ApiCalls';
import { LocalStorage } from '../../LocalStorage';

export interface ISelectedUserState {
  currency: string;
  user: ICrewData | null;
};

const initialState: ISelectedUserState = {
  currency: 'EUR',
  user: LocalStorage.user,
};

export const selectedUserSlice = createSlice({
  name: 'selectedUser',
  initialState,
  reducers: {
    selectUserCurrency: (state, action: PayloadAction<string>) => {
      state.currency = action.payload;
    },
    selectUser: (state, action: PayloadAction<ICrewData | null>) => {
      state.user = action.payload;
    },
  },
});

export const { selectUserCurrency, selectUser } = selectedUserSlice.actions;
export const selectedUserState = (state: RootState) => state.selectedUser.user;
export const selectedUserCurrencyState = (state: RootState) => state.selectedUser.currency;

export default selectedUserSlice.reducer;
